import { exec } from "child_process";
import IAsyncArgs from "../../../shared/contracts/IAsyncArgs";
import IQueuedReport from "../../../shared/contracts/IQueuedReport";
import useApi from "../../../shared/services/useApi.hook";
import IException from "../../../shared/contracts/IException";
import useAppStoreContext from "../../../shared/context/app-store/app-store.context";

function useReportApi() {
  const REPORT_SUBSCRIPTION='ReportSubscription';
  const REPORT = 'Report';
  const BASE_URL: string = `${process.env.REACT_APP_BASE_URL}/${REPORT}`;


  const { accessToken , tenantCode } = useAppStoreContext();
  
  const DEFAULT_HEADERS = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
    "Content-Type": "application/json",
    "Authorization": `Bearer ${accessToken}`
  };

  const {
    GET, POST,DELETE,PUT,
    TENANT_ID,
  } = useApi();

  
  const getQueuedReportsList = (
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IQueuedReport[]>
  ): void => {

    if (doIf()) {
      GET<IQueuedReport[]>(`${BASE_URL}/${REPORT_SUBSCRIPTION}/${TENANT_ID}`,
        doBefore,
        (fulfilled) => {
          console.log("API Response for Queued Reports List:", fulfilled);  // Log the response here
          onFulfilled(fulfilled);
        },
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const deleteReportSubscription = (reportId: number, taskId: number, {
    doBefore = () => {},
    doAfter = () => {},
    onFulfilled,
    onException = (exception: IException) => { console.warn('Exception during deleteReportSubscription:', exception); }
  }: IAsyncArgs<void>) => {

    DELETE(
      `${BASE_URL}/DeleteReportSubscription/${TENANT_ID}/${reportId}/${taskId}`,
      doBefore,
      onFulfilled,
      (rejection) => onException(rejection),
      onException,
      doAfter
    );
  };

  const cancelReportSubscription = async (reportId: number, taskId: number, {
    doBefore = () => {},
    doAfter = () => {},
    doIf = () => true,
    onFulfilled,
    onException = (exception: IException) => { console.warn('Exception during Cancel ReportSubscription:', exception); }
  }: IAsyncArgs<void>) => {
    
    if (doIf()) {
      PUT(
        `${BASE_URL}/CancelReportSubscription/${TENANT_ID}/${reportId}/${taskId}`,
        doBefore,
        onFulfilled,
        (_) => onException(new Error("Request rejected")),
        (exception) => onException(exception),
        doAfter
      );
    }
};

const downloadReport = (reportSubscriptionId: any, 
  { 
    doBefore = () => {}, 
    doAfter = () => {},
    onFulfilled, 
    onException = (exception: any) => { console.warn('exception', exception); } 
  }: any
) => {
  const url = `${BASE_URL}/Download/${TENANT_ID}/${reportSubscriptionId}`; 
  const requestOptions = {
    method: 'GET',
    headers: new Headers(DEFAULT_HEADERS) //added headers siva sai
  };
  
  doBefore();
  
  fetch(url, requestOptions)
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.blob();
    })
    .then(blob => {
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `${reportSubscriptionId}.xlsx`); 
      document.body.appendChild(link);
      link.click();
      // link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      onFulfilled();
    })
    .catch(exception => {
      onException(exception);
    })
    .finally(() => {
      doAfter();
    });
};


  // ---
  return {

    getQueuedReportsList,
    downloadReport,
    deleteReportSubscription,
    cancelReportSubscription
  }

}
export default useReportApi;